import { FCWithChildren } from '~/shared/types/FCWithChildren';
import { ToolbarProvider } from '~/shared/hooks/toolbar';
import { PraNotasCertificatesAlertManager } from '~/modules/praNotas/components/PraNotasCertificatesAlertManager';
import { OnboardingProvider } from '~/modules/onboarding/hooks/onboarding';

import { Toolbar } from '../../components/Toolbar';
import { SideBar } from '../../components/SideBar';
import { PageJourneyProvider } from '../../../modules/pageJourney/components/PageJourneyProvider';

import { Container, Content, MainWrapper } from './styles';

interface IDefaultLayoutProps {
  className: string;
}

export const DefaultLayout: FCWithChildren<IDefaultLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <OnboardingProvider>
      <PageJourneyProvider>
        <Container className={className}>
          <SideBar />

          <ToolbarProvider>
            <MainWrapper id="main-wrapper">
              <main id="main-element">
                <Toolbar />

                <PraNotasCertificatesAlertManager />

                <Content>{children}</Content>
              </main>
            </MainWrapper>
          </ToolbarProvider>
        </Container>
      </PageJourneyProvider>
    </OnboardingProvider>
  );
};
